import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import { PricingSerie } from './_models'

const PRODUCT_URL = '/p2c/reports'

const getPricingEvolution = (productId: ID, period: string): Promise<Array<PricingSerie>> => {
  return axios
    .get(`${PRODUCT_URL}/product/pricing-evolution?productId=${productId}&period=${period}`)
    .then((d: AxiosResponse<Response<Array<PricingSerie>>>) => {
      return d.data
    })
    .then((response: Response<Array<PricingSerie>>) => response.data || [])
}


export {
  getPricingEvolution
}
